//node_modules
import { useState, useEffect, useCallback } from "react";
import { PatternFormat } from "react-number-format";
// import { isValidPhoneNumber } from "react-phone-number-input";
import { useForm, Controller } from "react-hook-form";
import { Select } from "react-functional-select";
import toast from "react-hot-toast";
import axios from "axios";
import "tw-elements";

import checked from "../../assets/images/checked.png";
import unchecked from "../../assets/images/unchecked.png";
import checkingError from "../../assets/images/checking-error.png";
import TermsOfParticipation from "./TermsOfParticipation";
import PersonalDataProtection from "./PersonalDataProtection";

const CustomFormError = ({ children }) => (
  <span
    style={{
      width: "100%",
      marginTop: "0.25rem",
      fontSize: "0.875em",
      fontWeight: "600",
      color: "red",
    }}
  >
    {children}
  </span>
);

const Register = (props) => {
  const {
    control,
    handleSubmit,
    register,
    // reset,
    // clearErrors,
    // setError,
    // unregister,
    // getValues,
    // setValue,
    // getFieldState,
    watch,
    formState: { errors, isSubmitting },
  } = useForm({
    mode: "all",
  });

  const [uploading, setUploading] = useState(false);
  const [universities, setUniversites] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [cities, setCities] = useState([]);
  const [iclass, setClass] = useState([]);

  const getFilterOptionString = useCallback(
    (menuOption) => menuOption.data.value.toLocaleLowerCase("tr"),
    []
  );
  const fetchUniversites = () => {
    const url = "https://api.webeyondcreative.com/api/form/university";
    const token =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6Ikp6XVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIi5wibmFtZSI6Ikpva2G4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c";
    axios
      .get(url, {
        headers: {
          "X-Api-Token": token,
        },
      })
      .then((response) => {
        const universities = response.data;
        setUniversites(
          universities.map((university) => ({
            value: university.name,
            label: university.name,
          }))
        );
      });
  };
  const fetchDepartments = () => {
    const url = "https://api.webeyondcreative.com/api/form/department";
    const token =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6Ikp6XVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIi5wibmFtZSI6Ikpva2G4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c";
    axios
      .get(url, {
        headers: {
          "X-Api-Token": token,
        },
      })
      .then((response) => {
        const departments = response.data;
        setDepartments(
          departments.map((department) => ({
            value: department.name,
            label: department.name,
          }))
        );
      });
  };
  const fetchCities = () => {
    const url = "https://api.webeyondcreative.com/api/form/city";
    const token =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6Ikp6XVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIi5wibmFtZSI6Ikpva2G4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c";
    axios
      .get(url, {
        headers: {
          "X-Api-Token": token,
        },
      })
      .then((response) => {
        const cities = response.data;
        setCities(
          cities.map((city) => ({
            value: city.name,
            label: city.name,
          }))
        );
      });
  };
  const fetchClasses = () => {
    const url = "https://api.webeyondcreative.com/api/form/class";
    const token =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6Ikp6XVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIi5wibmFtZSI6Ikpva2G4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c";
    axios
      .get(url, {
        headers: {
          "X-Api-Token": token,
        },
      })
      .then((response) => {
        const classes = response.data;
        setClass(
          classes.map((iclass) => ({
            value: iclass.name,
            label: iclass.name,
          }))
        );
      });
  };
  const submitForm = (data) => {
    setUploading(true);
    axios.defaults.headers["X-Api-Token"] =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6Ikp6XVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIi5wibmFtZSI6Ikpva2G4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c";
    axios.defaults.headers["Access-Control-Allow-Origin"] = "*";
    axios.defaults.headers["Access-Control-Allow-Credentials"] = "true";

    const formData = new FormData();

    ["university", "department", "city", "class"].forEach((item) => {
      data[item] = data[item].value;
    });

    for (const [key, value] of Object.entries(data)) {
      formData.append(key, value);
    }

    axios
      .post(
        "https://api.webeyondcreative.com/api/form/store/we_bizztripunilever_2022",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((response) => {
        if (response.data.exists === "success") {
          setUploading(false);
          toast.success(
            props.currentLang === "tr"
              ? "Başvurunuz alındı. İlginiz için teşekkürler."
              : "Your application has been sent. Thank you for your attention."
          );
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else if (response.data.exists === "db_error") {
          setUploading(false);
          toast.error(
            props.currentLang === "tr"
              ? "Başvurunuz alınamadı!!"
              : "Your application hasn't been sent!"
          );
        } else if (response.data.errors.email) {
          setUploading(false);
        }
      })
      .catch((error) => {
        setUploading(false);
        toast.error(
          props.currentLang === "tr"
            ? "Bu e-posta adresi ile daha önce başvuru yapılmıştır!"
            : "This e-mail address has already been applied for!"
        );
        console.log(error);
      });
  };

  useEffect(() => {
    fetchUniversites();
    fetchDepartments();
    fetchClasses();
    fetchCities();
  }, []);

  return (
    <section
      id={props.currentLang === "eng" ? "register" : "kayit-ol"}
      className="w-full flex justify-center py-32 bg-[url(../../assets/images/register-bg.png)] bg-cover bg-top -mt-60"
    >
      <div data-aos="fade-up" className="w-4/5 max-w-screen-xl space-y-16">
        <div className="flex justify-center">
          <h4 className="text-green-custom font-bold text-4xl sm:text-5xl md:text-7xl text-center">
            {props.currentLang === "eng" ? "REGISTER" : "KAYIT OL"}
          </h4>
        </div>
        <div>
          <form onSubmit={handleSubmit(submitForm)} className="space-y-10">
            <div className="flex flex-col md:flex-row space-x-0 md:space-x-4 space-y-2 md:space-y-0">
              <div className="flex flex-col w-full md:w-1/2 space-y-2">
                <div className="form-group space-y-2">
                  <label
                    className="text-base font-medium text-green-custom"
                    htmlFor="firstname"
                  >
                    {props.currentLang === "eng" ? "Name" : "Ad"}
                  </label>
                  <input
                    {...register("firstname", {
                      required:
                        props.currentLang === "tr"
                          ? "Bu alan zorunlu!"
                          : "This field is required!",
                    })}
                    type="text"
                    className="error_firstname form-control block rounded-none w-full h-12 px-3 py-3 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:outline-none"
                    id="firstname"
                    aria-describedby="firstname"
                    placeholder={props.currentLang === "eng" ? "Name" : "Ad"}
                  />
                  <CustomFormError>{errors.firstname?.message}</CustomFormError>
                </div>
                <div className="form-group space-y-2">
                  <label
                    className="text-base font-medium text-green-custom"
                    htmlFor="surname"
                  >
                    {props.currentLang === "eng" ? "Surname" : "Soyad"}
                  </label>
                  <input
                    {...register("surname", {
                      required:
                        props.currentLang === "tr"
                          ? "Bu alan zorunlu!"
                          : "This field is required!",
                    })}
                    type="text"
                    className="form-control block rounded-none w-full h-12 px-3 py-3 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:outline-none"
                    id="surname"
                    aria-describedby="surname"
                    placeholder={
                      props.currentLang === "eng" ? "Surname" : "Soyad"
                    }
                  />
                  <CustomFormError>{errors.surname?.message}</CustomFormError>
                </div>
                <div className="form-group space-y-2">
                  <label
                    className="text-base font-medium text-green-custom"
                    htmlFor="email"
                  >
                    {props.currentLang === "eng" ? "E-Mail" : "E-Posta"}
                  </label>
                  <input
                    {...register("email", {
                      required:
                        props.currentLang === "tr"
                          ? "Bu alan zorunlu!"
                          : "This field is required!",
                      pattern: {
                        value: /\S+@\S+\./,
                        message:
                          props.currentLang === "tr"
                            ? "Yanlış e-posta formatı!"
                            : "Incorrect email format!",
                      },
                    })}
                    type="email"
                    className="custom-email-control form-control block rounded-none w-full h-12 px-3 py-3 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:outline-none lowercase placeholder:normal-case"
                    id="email"
                    aria-describedby="email"
                    placeholder={
                      props.currentLang === "eng" ? "E-Mail" : "E-Posta"
                    }
                  />
                  <CustomFormError>{errors.email?.message}</CustomFormError>
                </div>
                <Controller
                  control={control}
                  name="phone"
                  rules={{
                    required:
                      props.currentLang === "tr"
                        ? "Bu alan zorunlu!"
                        : "This field is required!",
                  }}
                  render={({
                    field: { onChange, onBlur, value, name, ref },
                    fieldState: { error },
                  }) => (
                    <div className="form-group space-y-2">
                      <label
                        className="text-base font-medium text-green-custom"
                        htmlFor="phone"
                      >
                        {props.currentLang === "eng" ? "Phone" : "Telefon"}
                      </label>
                      <PatternFormat
                        name={name}
                        getInputRef={ref}
                        onChange={onChange}
                        onBlur={onBlur}
                        value={value}
                        disabled={isSubmitting}
                        className="form-control block rounded-none w-full h-12 px-3 py-3 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:outline-none"
                        placeholder="0 5xx xxx xx xx"
                        format="0 ### ### ## ##"
                        mask="_"
                      />
                      <CustomFormError>
                        {error && error.message}
                      </CustomFormError>
                    </div>
                  )}
                />
              </div>
              <div className="flex flex-col w-full md:w-1/2 space-y-2">
                <Controller
                  control={control}
                  name="university"
                  rules={{
                    required:
                      props.currentLang === "tr"
                        ? "Bu alan zorunlu!"
                        : "This field is required!",
                  }}
                  render={({
                    field: { onChange, onBlur, value, name, ref, id },
                    fieldState: { error },
                  }) => (
                    <div
                      className="form-group space-y-2"
                      aria-invalid={!!error}
                    >
                      <label
                        className="text-base font-medium text-green-custom"
                        htmlFor="university"
                      >
                        {props.currentLang === "eng"
                          ? "University"
                          : "Üniversite"}
                      </label>
                      <Select
                        id={id}
                        ref={ref}
                        name={name}
                        isClearable
                        options={universities}
                        themeConfig={{
                          control: {
                            backgroundColor: "white",
                            borderRadius: 0,
                            height: "48px",
                            boxShadow: "none",
                          },
                        }}
                        placeholder={
                          props.currentLang === "eng" ? "Select" : "Seç"
                        }
                        onOptionChange={onChange}
                        onInputBlur={onBlur}
                        value={value}
                        filterIgnoreAccents={true}
                        getFilterOptionString={getFilterOptionString}
                      />
                      <CustomFormError>
                        {error && error.message}
                      </CustomFormError>
                    </div>
                  )}
                />
                <Controller
                  control={control}
                  name="department"
                  rules={{
                    required:
                      props.currentLang === "tr"
                        ? "Bu alan zorunlu!"
                        : "This field is required!",
                  }}
                  render={({
                    field: { onChange, onBlur, value, name, ref, id },
                    fieldState: { error },
                  }) => (
                    <div
                      className="form-group space-y-2"
                      aria-invalid={!!error}
                    >
                      <label
                        className="text-base font-medium text-green-custom"
                        htmlFor="department"
                      >
                        {props.currentLang === "eng" ? "Department" : "Bölüm"}
                      </label>
                      <Select
                        id={id}
                        ref={ref}
                        name={name}
                        isClearable
                        options={departments}
                        themeConfig={{
                          control: {
                            backgroundColor: "white",
                            borderRadius: 0,
                            height: "48px",
                            boxShadow: "none",
                          },
                        }}
                        placeholder={
                          props.currentLang === "eng" ? "Select" : "Seç"
                        }
                        onOptionChange={onChange}
                        onInputBlur={onBlur}
                        value={value}
                      />
                      <CustomFormError>
                        {error && error.message}
                      </CustomFormError>
                    </div>
                  )}
                />
                <Controller
                  control={control}
                  name="class"
                  rules={{
                    required:
                      props.currentLang === "tr"
                        ? "Bu alan zorunlu!"
                        : "This field is required!",
                  }}
                  render={({
                    field: { onChange, onBlur, value, name, ref, id },
                    fieldState: { error },
                  }) => (
                    <div
                      className="form-group space-y-2"
                      aria-invalid={!!error}
                    >
                      <label
                        className="text-base font-medium text-green-custom"
                        htmlFor="class"
                      >
                        {props.currentLang === "eng" ? "Class" : "Sınıf"}
                      </label>
                      <Select
                        id={id}
                        ref={ref}
                        name={name}
                        isClearable
                        options={iclass}
                        themeConfig={{
                          control: {
                            backgroundColor: "white",
                            borderRadius: 0,
                            height: "48px",
                            boxShadow: "none",
                          },
                        }}
                        placeholder={
                          props.currentLang === "eng" ? "Select" : "Seç"
                        }
                        onOptionChange={onChange}
                        onInputBlur={onBlur}
                        value={value}
                      />
                      <CustomFormError>
                        {error && error.message}
                      </CustomFormError>
                    </div>
                  )}
                />
                <Controller
                  control={control}
                  name="city"
                  rules={{
                    required:
                      props.currentLang === "tr"
                        ? "Bu alan zorunlu!"
                        : "This field is required!",
                  }}
                  render={({
                    field: { onChange, onBlur, value, name, ref, id },
                    fieldState: { error },
                  }) => (
                    <div
                      className="form-group space-y-2"
                      aria-invalid={!!error}
                    >
                      <label
                        className="text-base font-medium text-green-custom"
                        htmlFor="city"
                      >
                        {props.currentLang === "eng" ? "City" : "Şehir"}
                      </label>
                      <Select
                        id={id}
                        ref={ref}
                        name={name}
                        isClearable
                        options={cities}
                        themeConfig={{
                          control: {
                            backgroundColor: "white",
                            borderRadius: 0,
                            height: "48px",
                            boxShadow: "none",
                          },
                        }}
                        placeholder={
                          props.currentLang === "eng" ? "Select" : "Seç"
                        }
                        onOptionChange={onChange}
                        onInputBlur={onBlur}
                        value={value}
                        filterIgnoreAccents={true}
                        getFilterOptionString={getFilterOptionString}
                      />
                      <CustomFormError>
                        {error && error.message}
                      </CustomFormError>
                    </div>
                  )}
                />
              </div>
            </div>
            <div className="flex flex-col space-y-2">
              <label
                className="text-base font-medium text-green-custom"
                htmlFor="where-did-you-hear"
              >
                {props.currentLang === "eng"
                  ? "Where did you hear about BizzTrip?"
                  : "BizzTrip’i nereden duydun?"}
              </label>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4">
                <label
                  htmlFor="universityEvents"
                  className={
                    watch("wheredidyouhear") === "University Events"
                      ? "bg-green-custom form-check-label text-white py-4 flex items-center justify-center hover-bg-green-custom hover:text-white cursor-pointer text-center"
                      : "bg-white form-check-label text-green-custom py-4 flex items-center justify-center hover-bg-green-custom hover:text-white cursor-pointer text-center"
                  }
                >
                  {props.currentLang === "eng"
                    ? "University Events"
                    : "Üniversite Etkinlikleri"}
                </label>
                <label
                  htmlFor="landmarkEvents"
                  className={
                    watch("wheredidyouhear") === "Landmark Events"
                      ? "bg-green-custom form-check-label text-white py-4 flex items-center justify-center hover-bg-green-custom hover:text-white cursor-pointer text-center"
                      : "bg-white form-check-label text-green-custom py-4 flex items-center justify-center hover-bg-green-custom hover:text-white cursor-pointer text-center"
                  }
                >
                  {props.currentLang === "eng"
                    ? "Landmark Events"
                    : "Landmark Etkinlikleri"}
                </label>
                <label
                  htmlFor="socialMedia"
                  className={
                    watch("wheredidyouhear") === "Social Media"
                      ? "bg-green-custom form-check-label text-white py-4 flex items-center justify-center hover-bg-green-custom hover:text-white cursor-pointer text-center"
                      : "bg-white form-check-label text-green-custom py-4 flex items-center justify-center hover-bg-green-custom hover:text-white cursor-pointer text-center"
                  }
                >
                  {props.currentLang === "eng"
                    ? "Social Media"
                    : "Sosyal Medya"}
                </label>
                <label
                  htmlFor="friendsFamily"
                  className={
                    watch("wheredidyouhear") === "Friends/Family"
                      ? "bg-green-custom form-check-label text-white py-4 flex items-center justify-center hover-bg-green-custom hover:text-white cursor-pointer text-center"
                      : "bg-white form-check-label text-green-custom py-4 flex items-center justify-center hover-bg-green-custom hover:text-white cursor-pointer text-center"
                  }
                >
                  {props.currentLang === "eng"
                    ? "Friends/Family"
                    : "Arkadaş/Aile"}
                </label>
                <label
                  htmlFor="mailing"
                  className={
                    watch("wheredidyouhear") === "Mailing"
                      ? "bg-green-custom form-check-label text-white py-4 flex items-center justify-center hover-bg-green-custom hover:text-white cursor-pointer text-center"
                      : "bg-white form-check-label text-green-custom py-4 flex items-center justify-center hover-bg-green-custom hover:text-white cursor-pointer text-center"
                  }
                >
                  {props.currentLang === "eng" ? "Mailing" : "E-posta"}
                </label>
                <label
                  htmlFor="other"
                  className={
                    watch("wheredidyouhear") === "Other"
                      ? "bg-green-custom form-check-label text-white py-4 flex items-center justify-center hover-bg-green-custom hover:text-white cursor-pointer text-center"
                      : "bg-white form-check-label text-green-custom py-4 flex items-center justify-center hover-bg-green-custom hover:text-white cursor-pointer text-center"
                  }
                >
                  {props.currentLang === "eng" ? "Other" : "Diğer"}
                </label>
                <div className="hidden">
                  <input
                    className="hidden"
                    {...register("wheredidyouhear", {
                      required:
                        props.currentLang === "tr"
                          ? "Bu alan zorunlu!"
                          : "This field is required!",
                    })}
                    type="radio"
                    id="universityEvents"
                    value="University Events"
                  />
                  <input
                    className="hidden"
                    {...register("wheredidyouhear", {
                      required:
                        props.currentLang === "tr"
                          ? "Bu alan zorunlu!"
                          : "This field is required!",
                    })}
                    type="radio"
                    id="landmarkEvents"
                    value="Landmark Events"
                  />
                  <input
                    className="hidden"
                    {...register("wheredidyouhear", {
                      required:
                        props.currentLang === "tr"
                          ? "Bu alan zorunlu!"
                          : "This field is required!",
                    })}
                    type="radio"
                    id="socialMedia"
                    value="Social Media"
                  />
                  <input
                    className="hidden"
                    {...register("wheredidyouhear", {
                      required:
                        props.currentLang === "tr"
                          ? "Bu alan zorunlu!"
                          : "This field is required!",
                    })}
                    type="radio"
                    id="friendsFamily"
                    value="Friends/Family"
                  />
                  <input
                    className="hidden"
                    {...register("wheredidyouhear", {
                      required:
                        props.currentLang === "tr"
                          ? "Bu alan zorunlu!"
                          : "This field is required!",
                    })}
                    type="radio"
                    id="mailing"
                    value="Mailing"
                  />
                  <input
                    className="hidden"
                    {...register("wheredidyouhear", {
                      required:
                        props.currentLang === "tr"
                          ? "Bu alan zorunlu!"
                          : "This field is required!",
                    })}
                    type="radio"
                    id="other"
                    value="Other"
                  />
                </div>
              </div>
              <CustomFormError>
                {errors.wheredidyouhear?.message}
              </CustomFormError>
            </div>
            <div className="flex flex-col space-y-4">
              <div className="flex flex-row items-center space-x-3">
                <label
                  htmlFor="termsofparticipation"
                  className="cursor-pointer"
                >
                  <img
                    src={
                      errors.termsofparticipation
                        ? checkingError
                        : watch("termsofparticipation") === false
                        ? unchecked
                        : checked
                    }
                    alt="termsOfParticipationCheck"
                    width={24}
                  />
                </label>
                {props.currentLang === "eng" ? (
                  <p className="text-base font-normal text-black">
                    I accept{" "}
                    <span
                      data-bs-toggle="modal"
                      data-bs-target="#termsOfParticipationModal"
                      className="underline cursor-pointer"
                    >
                      the terms of participation
                    </span>
                    .
                  </p>
                ) : (
                  <p className="text-base font-normal text-black">
                    <span
                      data-bs-toggle="modal"
                      data-bs-target="#termsOfParticipationModal"
                      className="underline cursor-pointer"
                    >
                      Katılım şartlarını
                    </span>{" "}
                    kabul ediyorum.
                  </p>
                )}
                <input
                  className="hidden"
                  id="termsofparticipation"
                  type="checkbox"
                  {...register("termsofparticipation", {
                    required: "Bu alan zorunlu!",
                  })}
                />
              </div>
              <div className="flex flex-row space-x-3 items-start">
                <label
                  htmlFor="personaldataprotection"
                  className="cursor-pointer mt-1"
                >
                  <img
                    src={
                      errors.personaldataprotection
                        ? checkingError
                        : watch("personaldataprotection") === false
                        ? unchecked
                        : checked
                    }
                    alt="personalDataProtectionCheck"
                    width={24}
                  />
                </label>
                {props.currentLang === "eng" ? (
                  <p
                    className="text-base font-normal text-black"
                    style={{ maxWidth: "80%" }}
                  >
                    I consent to the use of my personal data that I provided to
                    Unilever Sanayi ve Ticaret Türk A.Ş. (Unilever) within the
                    scope of participation in the event, in accordance with{" "}
                    <span
                      data-bs-toggle="modal"
                      data-bs-target="#personalDataProtectionModal"
                      className="underline cursor-pointer"
                    >
                      the Personal Data Protection Law
                    </span>{" "}
                    No. 6698
                  </p>
                ) : (
                  <p
                    className="text-base font-normal text-black"
                    style={{ maxWidth: "80%" }}
                  >
                    Etkinlik katılımı kapsamında Unilever Sanayi ve Ticaret Türk
                    A.Ş (Unilever) sağladığım kişisel verilerimin{" "}
                    <span
                      data-bs-toggle="modal"
                      data-bs-target="#personalDataProtectionModal"
                      className="underline cursor-pointer"
                    >
                      6698 Sayılı Kişisel Verilerin Korunması Yönetmeliği
                    </span>{" "}
                    uyarınca kullanılmasına izin veriyorum.
                  </p>
                )}

                <input
                  className="hidden"
                  id="personaldataprotection"
                  type="checkbox"
                  {...register("personaldataprotection", {
                    required: "Bu alan zorunlu!",
                  })}
                />
              </div>
              <PersonalDataProtection
                isChecked={watch("personaldataprotection")}
              />
              <TermsOfParticipation isChecked={watch("termsofparticipation")} />
            </div>
            <div className="flex justify-center">
              <button
                type="submit"
                className="min-w-80 min-h-16 text-3xl text-white hover:text-yellow-400 font-bold bg-green-custom rounded-md px-10 md:px-24 py-4"
              >
                {uploading && (
                  <div className="flex justify-center items-center">
                    <div
                      className="spinner-border animate-spin inline-block w-8 h-8 border-4 rounded-full relative box-border"
                      role="status"
                    >
                      <div className="w-5 h-5 bg-green-custom rounded-t-full rounded-r-full absolute -top-3 right-0 box-border"></div>
                    </div>
                  </div>
                )}
                {!uploading && props.currentLang === "eng" && "REGISTER"}
                {!uploading && props.currentLang === "tr" && "KAYIT OL"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Register;
